import { Dispatch } from 'redux'

export const SET_FORM_LANGUAGE_RESTRICTION = 'FORM_RESTRICTIONS_SET_LANGUAGE'
export const CLEAR_FORM_LANGUAGE_RESTRICTION = 'FORM_RESTRICTIONS_CLEAR_LANGUAGE'
export const CLEAR_FORM_LANGUAGE_RESTRICTION_ONLY = 'FORM_RESTRICTIONS_CLEAR_LANGUAGE_ONLY'

interface SetFormLanguageRestrictionAction {
  type: typeof SET_FORM_LANGUAGE_RESTRICTION
  data: string[]
  originalLanguage?: string
}

interface ClearFormLanguageRestrictionAction {
  type: typeof CLEAR_FORM_LANGUAGE_RESTRICTION
}

interface ClearFormLanguageRestrictionOnlyAction {
  type: typeof CLEAR_FORM_LANGUAGE_RESTRICTION_ONLY
}

export type FormRestrictionsAction =
  | SetFormLanguageRestrictionAction
  | ClearFormLanguageRestrictionAction
  | ClearFormLanguageRestrictionOnlyAction

/**
 * Registers the languages a form supports and locks the topbar dropdown to those options.
 * Pass `originalLanguage` the first time a switch is needed so the pre-restriction language
 * survives navigation and can be restored when the lifecycle ends (first-write-wins).
 */
export function setFormLanguageRestriction (allowedLanguages: string[], originalLanguage?: string) {
  return (dispatch: Dispatch<FormRestrictionsAction>) => {
    dispatch({
      type: SET_FORM_LANGUAGE_RESTRICTION,
      data: allowedLanguages,
      originalLanguage
    })
  }
}

/**
 * Ends the restriction lifecycle entirely: unlocks the topbar dropdown and
 * discards the saved original language. Call this when the user leaves the
 * restricted flow (back-navigation, proactive restore, or safety-net unmount).
 */
export function clearFormLanguageRestriction () {
  return (dispatch: Dispatch<FormRestrictionsAction>) => {
    dispatch({ type: CLEAR_FORM_LANGUAGE_RESTRICTION })
  }
}

/**
 * Unlocks the topbar dropdown without discarding the saved original language.
 * Use when navigating from one restricted form to the next so the destination
 * form can still read `originalLanguage` and restore it on its own unmount.
 */
export function clearFormLanguageRestrictionOnly () {
  return (dispatch: Dispatch<FormRestrictionsAction>) => {
    dispatch({ type: CLEAR_FORM_LANGUAGE_RESTRICTION_ONLY })
  }
}
